import React, { useState } from "react";
import { FaMinus, FaPlus,FaUserMd, FaTabletAlt, FaCloud, FaRobot, FaLaptopMedical, FaMobileAlt, FaChartLine, FaFileMedical, FaHeartbeat, FaStethoscope } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcarePLS/digital.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Telemedicine & Remote Care",
        "description": "Revolutionizing healthcare delivery by enabling virtual consultations, remote patient monitoring, and digital engagement tools. Telemedicine reduces hospital admissions, enhances chronic disease management, and ensures real-time medical access for patients in underserved and remote areas. AI-driven chatbots, wearable device integration, and automated appointment scheduling further enhance patient experience and healthcare efficiency."
    },
    {
        "title": "Cloud-Based Health Records",
        "description": "Developing secure, interoperable Electronic Health Records (EHR) systems on cloud-based platforms to ensure seamless access and sharing of patient data among healthcare providers. These solutions improve coordination of care, enhance patient outcomes, and streamline administrative processes while adhering to strict security regulations such as HIPAA and GDPR. Blockchain integration further strengthens data integrity and prevents unauthorized modifications."
    },
    {
        "title": "Mobile Health (mHealth) Solutions",
        "description": "Empowering patients with mobile apps, wearables, and IoT-enabled health technologies that facilitate real-time health monitoring, medication reminders, and chronic disease management. mHealth solutions integrate with healthcare providers’ systems to enable remote tracking of vital signs such as heart rate, glucose levels, and blood pressure, supporting personalized treatment plans and preventive care strategies."
    },
    {
        "title": "AI-Powered Diagnostics",
        "description": "Enhancing diagnostic accuracy and efficiency through artificial intelligence and deep learning algorithms that analyze medical images, pathology reports, and genetic data. AI-driven diagnostic tools reduce human error, expedite disease detection, and provide clinical decision support for conditions like cancer, cardiovascular diseases, and neurodegenerative disorders. These innovations optimize resource utilization and improve patient outcomes."
    },
    {
        "title": "Healthcare Cybersecurity",
        "description": "Strengthening data protection in healthcare systems through advanced encryption, AI-driven threat detection, and multi-factor authentication. Cybersecurity measures prevent data breaches, ransomware attacks, and identity theft in medical institutions. Blockchain technology ensures immutable patient records, while zero-trust security models and regulatory compliance frameworks (HIPAA, ISO 27001) provide robust safeguards against evolving cyber threats."
    },
    {
        "title": "Big Data & Predictive Analytics",
        "description": "Transforming healthcare operations through predictive analytics, machine learning, and real-time data processing. Big data solutions analyze vast medical datasets to identify disease trends, predict patient deterioration, optimize hospital resource allocation, and improve clinical decision-making. These insights drive early interventions, reduce healthcare costs, and enhance the overall quality of care."
    }
]

const features = [
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "Remote patient monitoring and virtual healthcare services." },
    { icon: <FaCloud className="text-[#2a627a] text-lg" />, text: "Cloud-based electronic health records (EHR) for seamless data access." },
    { icon: <FaMobileAlt className="text-[#2a627a] text-lg" />, text: "Mobile health (mHealth) apps for real-time health tracking." },
    { icon: <FaRobot className="text-[#2a627a] text-lg" />, text: "AI-powered diagnostics and predictive analytics for early detection." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Data-driven insights for personalized patient care." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Enhanced cybersecurity and compliance for healthcare data protection." }
];
const benefits = [
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Improves access to healthcare with telemedicine solutions." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Enhances patient engagement through digital health platforms." },
    { icon: <FaCloud className="text-[#2a627a] text-lg" />, text: "Facilitates real-time data sharing for better clinical decisions." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Reduces healthcare costs with AI-driven efficiency." },
    { icon: <FaRobot className="text-[#2a627a] text-lg" />, text: "Supports precision medicine through advanced analytics." },
    { icon: <FaStethoscope className="text-[#2a627a] text-lg" />, text: "Enhances preventive care with wearable and IoT devices." }
];
const cmsFeatures = [
    {
        icon: <FaUserMd className="text-[#2a627a] text-lg" />,
        title: "Telemedicine Specialist",
        text: "Provides remote healthcare consultations and virtual patient management."
    },
    {
        icon: <FaTabletAlt className="text-[#2a627a] text-lg" />,
        title: "Health IT Developer",
        text: "Designs and implements healthcare software solutions for digital transformation."
    },
    {
        icon: <FaCloud className="text-[#2a627a] text-lg" />,
        title: "Healthcare Data Analyst",
        text: "Utilizes big data and AI to enhance patient care and operational efficiency."
    },
    {
        icon: <FaRobot className="text-[#2a627a] text-lg" />,
        title: "AI & Machine Learning Expert",
        text: "Develops predictive analytics and AI-driven diagnostics for precision medicine."
    }
];
const DigitalHealthSolutions = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex"> Digital Health Solutions - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Leveraging innovative, integrated, and patient-centered digital tools to transform healthcare delivery and outcomes."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Digital Health Solutions?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Digital health solutions integrate technology with healthcare to enhance patient care, streamline operations,
                            and improve medical outcomes. At HIKEHEALTH GS, we utilize telemedicine, AI-driven diagnostics, wearable health
                            devices, and electronic health records to provide real-time monitoring and personalized treatment plans. Our
                            goal is to make healthcare more accessible, efficient, and data-driven for better patient experiences.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Digital Health Solutions
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default DigitalHealthSolutions;
